/**
 * Store Location Mapping
 * Maps store shortName to address and timezone information
 */

export const storeLocationMapping = {
  // Alabama
  "Hoover": {
    address: {
      street1: "5225 Peridot Place",
      street2: "Suite 121",
      city: "Hoover",
      state: "AL",
      zip: "35244",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Huntsville": {
    address: {
      street1: "2724 Carl T Jones Dr SE",
      street2: null,
      city: "Huntsville",
      state: "AL",
      zip: "35802",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  
  // Arizona
  "Casa Paloma": {
    address: {
      street1: "7131 W. Ray Rd",
      street2: "Ste. 23",
      city: "Chandler",
      state: "AZ",
      zip: "85226",
      country: "US"
    },
    timeZone: "America/Phoenix"
  },
  "WW DC Ranch": {
    address: {
      street1: "20715 N. Pima Rd",
      street2: "Ste. F-115",
      city: "Scottsdale",
      state: "AZ",
      zip: "85255",
      country: "US"
    },
    timeZone: "America/Phoenix"
  },
  "Old Town": {
    address: {
      street1: "4000 N. Scottsdale Rd",
      street2: "Ste. 105",
      city: "Scottsdale",
      state: "AZ",
      zip: "85251",
      country: "US"
    },
    timeZone: "America/Phoenix"
  },
  "Park West": {
    address: {
      street1: "9788 W. Northern Ave",
      street2: "Ste. 1440",
      city: "Peoria",
      state: "AZ",
      zip: "85345",
      country: "US"
    },
    timeZone: "America/Phoenix"
  },
  "San Tan": {
    address: {
      street1: "2168 E. Williams Field Rd",
      street2: "Ste. 102",
      city: "Gilbert",
      state: "AZ",
      zip: "85295",
      country: "US"
    },
    timeZone: "America/Phoenix"
  },
  "SQ": {
    address: {
      street1: "15147 N. Scottsdale Rd",
      street2: "Ste. H-135",
      city: "Scottsdale",
      state: "AZ",
      zip: "85254",
      country: "US"
    },
    timeZone: "America/Phoenix"
  },
  
  // Florida
  "Bell Tower": {
    address: {
      street1: "13499 S. Cleveland Ave",
      street2: "Ste. 201",
      city: "Fort Myers",
      state: "FL",
      zip: "33907",
      country: "US"
    },
    timeZone: "America/New_York"
  },
  "DATG Palm Beach": {
    address: {
      street1: "11701 Lake Victoria Gardens Ave",
      street2: "3101",
      city: "Palm Beach Gardens",
      state: "FL",
      zip: "33410",
      country: "US"
    },
    timeZone: "America/New_York"
  },
  "Destin": {
    address: {
      street1: "780 Grand Boulevard",
      street2: "Ste. 100",
      city: "Miramar Beach",
      state: "FL",
      zip: "32550",
      country: "US"
    },
    timeZone: "America/New_York"
  },
  "WS West Shore": {
    address: {
      street1: "218 Westshore Plaza",
      street2: null,
      city: "Tampa",
      state: "FL",
      zip: "33609",
      country: "US"
    },
    timeZone: "America/New_York"
  },
  
  // Iowa
  "Ankeny": {
    address: {
      street1: "1450 SW Vintage Pkwy",
      street2: null,
      city: "Ankeny",
      state: "IA",
      zip: "50023",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "West Des Moines": {
    address: {
      street1: "5485 Mills Civic Pkwy",
      street2: null,
      city: "West Des Moines",
      state: "IA",
      zip: "50266",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  
  // Idaho
  "Meridian": {
    address: {
      street1: "3573 Longwing Lane",
      street2: "Suite 130",
      city: "Meridian",
      state: "ID",
      zip: "83646",
      country: "US"
    },
    timeZone: "America/Denver"
  },
  
  // Kansas
  "Prairiefire": {
    address: {
      street1: "5601 W. 135th Street",
      street2: "Suite 2240",
      city: "Overland Park",
      state: "KS",
      zip: "66223",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Waterfront": {
    address: {
      street1: "1441 N. Webb Road",
      street2: null,
      city: "Wichita",
      state: "KS",
      zip: "67206",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  
  // Kentucky
  "Fritz Farm": {
    address: {
      street1: "118 Marion",
      street2: "Suite 110",
      city: "Lexington",
      state: "KY",
      zip: "40517",
      country: "US"
    },
    timeZone: "America/New_York"
  },
  
  // Nevada
  "Boca": {
    address: {
      street1: "750 S. Rampart Blvd",
      street2: "Ste. 7",
      city: "Las Vegas",
      state: "NV",
      zip: "89145",
      country: "US"
    },
    timeZone: "America/Los_Angeles"
  },
  "Green Valley": {
    address: {
      street1: "9595 S. Eastern Ave",
      street2: "Ste. 100",
      city: "Las Vegas",
      state: "NV",
      zip: "89123",
      country: "US"
    },
    timeZone: "America/Los_Angeles"
  },
  "Palazzo": {
    address: {
      street1: "3327 Las Vegas Blvd",
      street2: "Ste. 2710",
      city: "Las Vegas",
      state: "NV",
      zip: "89109",
      country: "US"
    },
    timeZone: "America/Los_Angeles"
  },
  "South Rainbow": {
    address: {
      street1: "7155 S. Rainbow Blvd",
      street2: "Ste. 125",
      city: "Las Vegas",
      state: "NV",
      zip: "89118",
      country: "US"
    },
    timeZone: "America/Los_Angeles"
  },
  "Sparks": {
    address: {
      street1: "1180 Scheel's Dr",
      street2: "Ste. B-117",
      city: "Sparks",
      state: "NV",
      zip: "89434",
      country: "US"
    },
    timeZone: "America/Los_Angeles"
  },
  
  // New York
  "Brooklyn": {
    address: {
      street1: "1 Front Street",
      street2: null,
      city: "Brooklyn",
      state: "NY",
      zip: "11201",
      country: "US"
    },
    timeZone: "America/New_York"
  },
  
  // South Carolina
  "Mt. Pleasant": {
    address: {
      street1: "1244 Belk Dr.",
      street2: null,
      city: "Mt. Pleasant",
      state: "SC",
      zip: "29464",
      country: "US"
    },
    timeZone: "America/New_York"
  },
  
  // Texas
  "Baybrook": {
    address: {
      street1: "700 Baybrook Mall",
      street2: "Ste 117",
      city: "Friendswood",
      state: "TX",
      zip: "77546",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Cinco Ranch": {
    address: {
      street1: "2643 Commercial Center Blvd.",
      street2: "Ste C390",
      city: "Katy",
      state: "TX",
      zip: "77494",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "CITYCENTRE": {
    address: {
      street1: "12848 Queensbury Lane",
      street2: "Suite 101",
      city: "Houston",
      state: "TX",
      zip: "77024",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Domain": {
    address: {
      street1: "11700 Domain Blvd",
      street2: "#148",
      city: "Austin",
      state: "TX",
      zip: "78758",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "El Paso": {
    address: {
      street1: "8889 Gateway Blvd. West",
      street2: "Suite 1200",
      city: "El Paso",
      state: "TX",
      zip: "79925",
      country: "US"
    },
    timeZone: "America/Denver"
  },
  "First Colony": {
    address: {
      street1: "16535 Southwest Freeway",
      street2: "Ste 2500",
      city: "Sugar Land",
      state: "TX",
      zip: "77479",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Grapevine": {
    address: {
      street1: "1401 William D. Tate Avenue",
      street2: "Ste 100",
      city: "Grapevine",
      state: "TX",
      zip: "76051",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Highland Village": {
    address: {
      street1: "1101 Shoal Creek",
      street2: "Suite 110",
      city: "Highland Village",
      state: "TX",
      zip: "75077",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "La Cantera": {
    address: {
      street1: "15900 La Cantera Pkwy",
      street2: "Ste 25180",
      city: "San Antonio",
      state: "TX",
      zip: "78256",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "La Palmera": {
    address: {
      street1: "5488 S. Padre Island",
      street2: "Ste 1202",
      city: "Corpus Christi",
      state: "TX",
      zip: "78411",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Park Lane": {
    address: {
      street1: "8060 Park Lane N",
      street2: "Ste 105",
      city: "Dallas",
      state: "TX",
      zip: "75231",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Quarry Village": {
    address: {
      street1: "330 E. Basse Rd",
      street2: "Ste 101",
      city: "San Antonio",
      state: "TX",
      zip: "78209",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Stone Oak": {
    address: {
      street1: "22810 US Hwy. 281 N.",
      street2: "Suite 105",
      city: "San Antonio",
      state: "TX",
      zip: "78258",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Fort Worth": {
    address: {
      street1: "5276 Monahans Ave.",
      street2: null,
      city: "Fort Worth",
      state: "TX",
      zip: "76109",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Legacy": {
    address: {
      street1: "5717 Legacy Dr.",
      street2: "Suite 110",
      city: "Plano",
      state: "TX",
      zip: "75024",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Towncenter": {
    address: {
      street1: "20 Waterway Ave",
      street2: "Ste 100",
      city: "Woodlands",
      state: "TX",
      zip: "77380",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Irving": {
    address: {
      street1: "310 West Las Colinas Boulevard",
      street2: "Suite 100",
      city: "Irving",
      state: "TX",
      zip: "75039",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Watters Creek": {
    address: {
      street1: "836 Watters Creek Blvd",
      street2: "C-200",
      city: "Allen",
      state: "TX",
      zip: "75013",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "West Village": {
    address: {
      street1: "3636 McKinney Ave",
      street2: "Ste 190",
      city: "Dallas",
      state: "TX",
      zip: "75204",
      country: "US"
    },
    timeZone: "America/Chicago"
  },
  "Realm": {
    address: {
      street1: "4440 SH 121",
      street2: null,
      city: "Lewisville",
      state: "TX",
      zip: "75056",
      country: "US"
    },
    timeZone: "America/Chicago"
  },

  // Wisconsin
  "Brookfield": {
    address: {
      street1: "20119 Lord Street",
      street2: "Space J-101",
      city: "Brookfield",
      state: "WI",
      zip: "53045",
      country: "US"
    },
    timeZone: "America/Chicago"
  }
};

/**
 * Get location data for a store
 * @param {string} shortName - The store's short name
 * @returns {object|null} Location data with address and timeZone, or null if not found
 */
export function getStoreLocation(shortName) {
  return storeLocationMapping[shortName] || null;
}

/**
 * Get timezone for a store
 * @param {string} shortName - The store's short name
 * @returns {string} The timezone string, defaults to "America/Chicago" if not found
 */
export function getStoreTimeZone(shortName) {
  const location = storeLocationMapping[shortName];
  return location?.timeZone || "America/Chicago";
}

/**
 * Get address for a store
 * @param {string} shortName - The store's short name
 * @returns {object|null} The address object or null if not found
 */
export function getStoreAddress(shortName) {
  const location = storeLocationMapping[shortName];
  return location?.address || null;
}